import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    router.navigate(['/auth/login']);
    return false;
  }

  // Patients should use the dedicated patient portal, not the staff layout
  if (authService.currentUser()?.role === 'patient') {
    router.navigate(['/patient-portal']);
    return false;
  }

  return true;
};
